import { applyMiddleware, compose } from 'redux'
import { middleware as flashMiddleware } from 'redux-flash'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import history from './history'
import promiseMiddleware from 'redux-promise-middleware'
import requestErrorMiddleware from './request-error-middleware'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const middleware = [
  promiseMiddleware,
  requestErrorMiddleware,
  history,
  flashMiddleware(),
  thunk.withExtraArgument({
  })
]

middleware.push(logger)

export default composeEnhancers(
  applyMiddleware(...middleware)
)
